import { render, staticRenderFns } from "./ModifyBook.vue?vue&type=template&id=5d0d8449&scoped=true"
import script from "./ModifyBook.vue?vue&type=script&lang=js"
export * from "./ModifyBook.vue?vue&type=script&lang=js"
import style0 from "./ModifyBook.vue?vue&type=style&index=0&id=5d0d8449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d8449",
  null
  
)

export default component.exports